import { ApiProperty } from '@nestjs/swagger';
import { Exclude, Expose } from 'class-transformer';

import { BoardExcelFloorBaseDto } from './board-excel-floor-base.dto';
import { BoardExcelFloorErrorEnum } from '../enums/board-excel-floor-error.enum';
import { BoardExcelFloorInterface } from '../interfaces/board-excel-floor.interface';

@Exclude()
export class BoardExcelFloorDto implements BoardExcelFloorInterface {
  @ApiProperty({
    title: 'Errors',
    description: 'List of errors occurred during the process.',
    type: 'array',
  })
  @Expose()
  errors!: { type: BoardExcelFloorErrorEnum; message: string }[];

  @ApiProperty({
    title: 'Board Types',
    type: BoardExcelFloorBaseDto,
    description: 'Data from excel parsed to BoardTypeFloorDto.',
  })
  @Expose()
  boardExcelFloors!: BoardExcelFloorBaseDto[];
}
